import { client } from './client';
import interceptors from './interceptors';
import qs from 'qs';

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function bankAccount() {
    return client.get('/tunnel/api/public/general/bank-account');
}

function bankData() {
    return client.get('/tunnel/api/public/general/bank');
}

function dataBank(param) {
    return client.get('/tunnel/api/member/bank/data', {
        params: param
    });
}

function addBank(params) {
    return client.post('/tunnel/api/member/bank/add', qs.stringify(params), {
        header: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
}

function deleteBank(params) {
    return client.post('/tunnel/api/member/bank/delete', qs.stringify(params), {
        header: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
}

function updateStatusBank(params) {
    return client.post('/tunnel/api/member/bank/status', qs.stringify(params), {
        header: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
}

function updateBank(params) {
    return client.post('/tunnel/api/member/bank/edit', qs.stringify(params), {
        header: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
}

export default {
    bankAccount,
    bankData,
    dataBank,
    addBank,
    deleteBank,
    updateStatusBank,
    updateBank
};